import { render } from "./DownloadReportsModal.vue?vue&type=template&id=0c3a7dad"
import script from "./DownloadReportsModal.vue?vue&type=script&lang=js"
export * from "./DownloadReportsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__